/* Global Duniya — clay interactions: reveal on scroll, header state, cart bump, hero parallax. */
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.gdReady = true;

  /* ---------- header shadow on scroll (always on) ---------- */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      root.classList.toggle('gd-scrolled', window.scrollY > 24);
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- cart bubble bump + add-to-cart jelly ---------- */
  function bump(el, cls) {
    if (!el || reduce) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    el.addEventListener('animationend', function done() {
      el.classList.remove(cls);
      el.removeEventListener('animationend', done);
    });
  }
  document.addEventListener('cart:update', function () {
    document.querySelectorAll('.cart-bubble').forEach(function (b) { bump(b, 'gd-bump'); });
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.add-to-cart-button, button[name="add"], .gd-btn');
    if (btn) bump(btn, 'gd-jelly');
  });

  if (reduce || !('IntersectionObserver' in window)) {
    root.classList.remove('gd-js');
    return;
  }
  root.classList.add('gd-js');

  /* ---------- reveal on scroll ---------- */
  var SELECTOR = '[data-gd-reveal], main .product-card';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -5% 0px', threshold: 0.05 });

  function watch(scope) {
    var groups = new Map();
    (scope || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.dataset.gdWatched) return;
      el.dataset.gdWatched = '1';
      if (el.matches('main .product-card')) {
        var parent = el.parentElement && el.parentElement.parentElement;
        var n = groups.get(parent) || 0;
        groups.set(parent, n + 1);
        el.style.setProperty('--gd-i', String(n % 4));
      }
      io.observe(el);
    });
  }

  function revealVisible() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
    });
  }

  function start() {
    watch(document);
    var main = document.querySelector('main') || document.body;
    new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        if (mutations[m].addedNodes.length) { watch(main); break; }
      }
    }).observe(main, { childList: true, subtree: true });
    setTimeout(revealVisible, 1600);
    initHero();
  }

  /* ---------- hero bubbles parallax ---------- */
  function initHero() {
    var hero = document.querySelector('[data-gd-hero]');
    if (!hero || !window.matchMedia('(hover: hover)').matches) return;
    var bubbles = hero.querySelectorAll('.gd-bubble');
    var raf = 0;
    hero.addEventListener('pointermove', function (e) {
      var rect = hero.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        bubbles.forEach(function (b) {
          var d = parseFloat(b.dataset.depth || '10');
          b.style.setProperty('--gd-px', (x * d * 2).toFixed(1) + 'px');
          b.style.setProperty('--gd-py', (y * d * 2).toFixed(1) + 'px');
        });
      });
    });
    hero.addEventListener('pointerleave', function () {
      bubbles.forEach(function (b) {
        b.style.setProperty('--gd-px', '0px');
        b.style.setProperty('--gd-py', '0px');
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) { watch(e.target); initHero(); });
})();
